<script setup lang="ts">
const route = useRoute()

const isPro = computed(() => route.path.startsWith('/entreprises'))

const siteConfig = useSiteConfig()
const ogImageUrl = `${siteConfig.url}/images/og-image.jpg`

useSeoMeta({
  ogImage: ogImageUrl,
  ogImageWidth: 1200,
  ogImageHeight: 630,
  twitterCard: 'summary_large_image',
  twitterImage: ogImageUrl,
})

useHead(() => ({
  link: [
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: isPro.value ? '/favicon-pro.ico' : '/favicon-particulier.ico',
    },
  ],
}))

useSchemaOrg([
  defineWebSite({
    name: 'Deboosere Chauffage Sanitaire',
    description: "Plombier chauffagiste à Lille — dépannage urgence, installation et entretien pour particuliers et professionnels dans la métropole lilloise.",
    inLanguage: 'fr',
  }),
  defineLocalBusiness({
    name: 'Deboosere Chauffage et Sanitaire',
    description: "Plombier chauffagiste à Lille et dans la métropole lilloise. Dépannage urgence, installation, entretien pour particuliers et professionnels.",
    telephone: '+33789464309',
    areaServed: [
      { '@type': 'City', name: 'Lille' },
      { '@type': 'City', name: 'Roubaix' },
      { '@type': 'City', name: 'Tourcoing' },
      { '@type': 'City', name: "Villeneuve-d'Ascq" },
      { '@type': 'City', name: 'Marcq-en-Barœul' },
    ],
    priceRange: '€€',
    sameAs: ['https://www.facebook.com/p/Deboosere-Chauffage-sanitaire-100063721472973/'],
  })
])


</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>